import { useContext, useMemo } from 'react';
import type { CSSObjectWithLabel } from 'react-select';
import Select from 'react-select';
import { Checkbox } from '@trinity/chat-components/components/presentation/Checkbox.js';
import { TagFormContext, TagStateContext } from './Context';
import styles from './style/CreateTagModal.module.css';
import { ColorSelect } from './Tagging.ColorSelect';

type Props = {
  disableParent?: boolean;
  excludeParentIds?: number[];
};

export const TagForm = ({ disableParent = false, excludeParentIds = [] }: Props) => {
  const { data, dispatch } = useContext(TagFormContext);
  const { state } = useContext(TagStateContext);

  const parentOptions = useMemo(() => {
    return state.tags.filter(t => !excludeParentIds.includes(t.id)).map(t => ({
      value: t.id,
      label: t.base.name,
    }));
  }, [state, excludeParentIds]);
  const categoryOptions = useMemo(() => {
    return [
      { value: 'transcript', label: 'Transcript Tag' },
      { value: 'files', label: 'Files Tags' },
    ];
  }, []);
  const parentValue = parentOptions.find(o => o.value === data.parentId);
  const categoryValue = categoryOptions.find(o => o.value === data.category);

  return (
    <>
      <Section title='Tag Title'>
        <div className={styles.field}>
          <input
            className={styles.input}
            value={data.title}
            onChange={e => dispatch({ title: e.target.value })}
            placeholder='Input Title' />
        </div>
      </Section>
      <Section title='Tag Category'>
        <Select
          value={categoryValue ?? { value: null, label: 'None' }}
          options={categoryOptions}
          getOptionLabel={o => o.label}
          isClearable={true}
          menuPortalTarget={document.body}
          styles={{ menuPortal: base => ({ ...base, zIndex: 8 }) as CSSObjectWithLabel }}
          onChange={v => dispatch({ category: v?.value })} />
      </Section>
      <Section title='Parent'>
        <Select
          isDisabled={disableParent}
          value={parentValue ?? { value: null, label: 'None' }}
          options={parentOptions}
          getOptionLabel={o => o.label}
          isClearable={true}
          menuPortalTarget={document.body}
          styles={{ menuPortal: base => ({ ...base, zIndex: 8 }) as CSSObjectWithLabel }}
          onChange={v => dispatch({ parentId: v?.value })} />
      </Section>
      <Section title='Color'>
        <ColorSelect color={data.color} onChange={c => dispatch({ color: c })} />
      </Section>
      <Section title='Include Summary'>
        <Checkbox checked={data.includeSummary} onChange={c => dispatch({ includeSummary: c.target.checked })} />
      </Section>
    </>
  );
};

type SectionProps = { title: string } & ChildrenProps;
const Section = (props: SectionProps) => {
  return (
    <div>
      <div className={styles.section}>
        <div className={styles.title}>{props.title}</div>
        {props.children}
      </div>
    </div>
  );
};